import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import envManager from "../../../services/managers/env";
import browserManager from "../../../services/managers/browser";
import alertMessageManager from "../../../services/managers/alert-message";
import * as actionCreators from "../../../store/analytics/chart-download/action-creators";
import { MSG_ERR_DOWNLOAD_NOT_SUPPORTED, TOOLTIP_DOWNLOAD_IMAGE } from "../../../services/managers/string-literals";

class ChartDownload extends React.Component {
  handleDownloadClick() {
    if (_.includes(envManager.getDownloadSupportedBrowsers(), browserManager.getName())) {
      this.props.onDownloadClick(this.props.whiteboardIndex);
    } else {
      // Show error if browser not supported
      alertMessageManager.show("whiteboardAlertError" + this.props.whiteboardIndex, MSG_ERR_DOWNLOAD_NOT_SUPPORTED);
    }
  }

  render() {
    // Disable Download if there are no charts or the whiteboard is obsolete
    let isDisabled = !this.props.chartDrawingsLength || this.props.isWhiteboardObsolete ? { disabled: "disabled" } : {};

    return (
      <button className="btn btn--link" onClick={() => this.handleDownloadClick()} {...isDisabled} title={TOOLTIP_DOWNLOAD_IMAGE}>
        <i className="icon-cme-download" /> Download Image
      </button>
    );
  }
}

ChartDownload.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  onDownloadClick: (whiteboardIndex) => dispatch(actionCreators.onDownloadClick({ whiteboardIndex }))
});

export default connect(null, mapDispatchToProps)(ChartDownload);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartDownload/ChartDownload.js